{% block klarna_payment_plugin_icon %}
    <img :src="assetFilter('/klarnapayment/administration/static/plugin.png')">
{% endblock %}
